import styles from "./summaryContainer.module.css";

const DEFAULT_CLASSES = {
  container: styles.container,
  header: styles.header,
  title: styles.title,
  titleIcon: styles.titleIcon,
  content: styles.content,
  actionButton: styles.actionButton,
  actionButtonIcon: styles.actionButtonIcon,
};

export default function SummaryContainer({
  title = "",
  titleIcon = null,
  onAction = () => {},
  actionButtonTitle = "",
  actionButtonIcon = null,
  disabled = false,
  cartSummaryClassesOverride = {},
  cartSummaryStyles = {},
  children,
  error = null,
  collapsible = false,
  expanded = true,
  onToggle = () => {}
}) {
  const classes = { ...DEFAULT_CLASSES, ...cartSummaryClassesOverride };
  const bodyVisible = !collapsible || expanded;

  return (
    <aside className={classes.container} style={cartSummaryStyles.container}>
      {(title || titleIcon) && (
        <div
          className={`${classes.header} ${collapsible ? styles.collapsibleHeader : ""}`}
          style={cartSummaryStyles.header}
          onClick={collapsible ? onToggle : undefined}
          onKeyDown={collapsible ? (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onToggle();
            }
          } : undefined}
          role={collapsible ? "button" : undefined}
          tabIndex={collapsible ? 0 : undefined}
          aria-expanded={collapsible ? expanded : undefined}
        >
          {title ? <h2 className={classes.title} style={cartSummaryStyles.title}>{title}</h2> : null}
          {titleIcon ? (
            <div className={classes.titleIcon} style={cartSummaryStyles.titleIcon}>{titleIcon}</div>
          ) : null}
        </div>
      )}

      {bodyVisible && children ? (
        <div className={classes.content} style={cartSummaryStyles.content}>{children}</div>
      ) : null}

      {bodyVisible && error ? (
        <p
          className={styles.errorMessage}
          style={cartSummaryStyles.errorMessage}
          role="alert"
        >
          {error}
        </p>
      ) : null}

      {bodyVisible && actionButtonTitle ? (
        <button
          type="button"
          className={classes.actionButton}
          style={cartSummaryStyles.actionButton}
          onClick={onAction}
          disabled={disabled}
        >
          <span>{actionButtonTitle}</span>
          {actionButtonIcon ? (
            <span
              className={classes.actionButtonIcon}
              style={cartSummaryStyles.actionButtonIcon}
            >
              {actionButtonIcon}
            </span>
          ) : null}
        </button>
      ) : null}
    </aside>
  );
}
